/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

export function AdminByBook() {
  const [items, setItems] = useState<any[]>([]);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const history = useHistory();
  const dispatch = useDispatch();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getStatistics();
  }, []);

  // 도서별 판매 통계 API 호출
  const getStatistics = async () => {
    await server
      .getOrderStatistics(startDate, endDate)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setItems(payload);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 데이터값 불러오기
  const ByBookRow = items?.map((item: any, index: number) => (
    <ul className="row" key={Math.random()}>
      <li className="counter">{index + 1}</li>
      <li className="code">{item.bookCode}</li>
      <li className="book-title">{item.bookName}</li>
      <li className="quantity">{Number(item.orderQty).toLocaleString()}</li>
      <li className="price">{Number(item.bookPrice).toLocaleString()}</li>
      <li className="percentage">{Number(item.persentAge).toFixed(1)}</li>
    </ul>
  ));

  // 기간 검색
  function createTableHeader() {
    return (
      <div className="search">
        <div className="date">
          <label htmlFor="from">기간검색</label>
          <input
            type="text"
            id="from"
            name="from"
            placeholder="2022-01-01"
            onChange={(event) => {
              setStartDate(event.target.value);
            }}
          />
          <input
            type="text"
            id="to"
            name="to"
            placeholder="2022-02-01"
            onChange={(event) => {
              setEndDate(event.target.value);
            }}
          />
        </div>
        <button
          onClick={() => {
            getStatistics();
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
          </svg>
        </button>
      </div>
    );
  }

  // 분류 제목
  function createBookList() {
    return (
      <div className="table">
        <ul className="row title">
          <li className="counter">순위</li>
          <li className="code">상품 코드</li>
          <li className="book-title">상품명</li>
          <li className="quantity">판매량</li>
          <li className="price">판매가</li>
          <li className="percentage">판매율</li>
        </ul>
        {ByBookRow}
      </div>
    );
  }

  // AdminByBook 리턴값
  return (
    <main className="list-books-statistics wrapper">
      <div className="title">
        <h1>도서별 판매 통계</h1>
      </div>
      <div className="content">
        <div className="table-header">{createTableHeader()}</div>
        {createBookList()}
      </div>
    </main>
  );
}
